import React from 'react';
import PropTypes from 'prop-types';
import Education from './Education';
import { degreeTitles } from './const';
import WithImpressions from '../../../WithImpressions';

export default function EducationList({ educations, biData }) {
    if (!educations.length) { return null; }

    const seller_card_about_me_education = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_education_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_education' },
            element: {
                position: biData.position,
                type: 'text',
                metadata: 'Education',
                text: educations.map((education) => `${degreeTitles[education.degree_title]} ${education.degree}`).toString(),
                name: 'seller_card_about_me_education',
                visible: true
            }
        }
    };

    return (
        <WithImpressions value={seller_card_about_me_education} className="education-list list">
            <h3>{i18n.t('seller_profile.education')}</h3>
            <ul>
                {educations.map((education, idx) => {
                    const degreeTitle = degreeTitles[education.degree_title];

                    const educationData = {
                        degree_title: degreeTitle,
                        ...education
                    };

                    return (<Education education={educationData} key={idx}/>);
                })}
            </ul>
        </WithImpressions>
    );
}

EducationList.propTypes = {
    educations: PropTypes.array,
    biData: PropTypes.object
};

EducationList.defaultProps = {
    educations: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/EducationList/index.js